import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useBreakpoints } from '@src/utils/breakpoints.util';
interface UseLockScrollArgs {
  isExpanded: boolean;
}
export const useLockScroll = t0 => {
  const $ = _c(4);
  const {
    isExpanded
  } = t0;
  const scrollTop = useRef(0);
  const breakpoints = useBreakpoints();
  const isMobile = breakpoints.isMobile || breakpoints.isTablet;
  let t1;
  let t2;
  if ($[0] !== isExpanded || $[1] !== isMobile) {
    t1 = () => {
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      if (body && html && isMobile) {
        if (isExpanded) {
          scrollTop.current = window.scrollY;
        }
        body.style.overflow = isExpanded ? "hidden" : "";
        body.style.position = isExpanded ? "relative" : "";
        body.style.height = isExpanded ? "100%" : "";
        html.style.overflow = isExpanded ? "hidden" : "";
        html.style.height = isExpanded ? "100%" : "";
        if (!isExpanded) {
          window.scrollTo(0, scrollTop.current);
        }
        return () => {
          body.style.overflow = "";
          body.style.position = "";
          body.style.height = "";
          html.style.overflow = "";
          html.style.height = "";
        };
      }
    };
    t2 = [isExpanded, isMobile];
    $[0] = isExpanded;
    $[1] = isMobile;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
};